import moment from "moment";

export enum ActionType {
  ClearSearchTerm = "CLEAR_SEARCH_TERM",
  HandleRecentSearchTermClick = "HANDLE_RECENT_SEARCH_TERM_CLICK",
  ResetFilters = "RESET_FILTERS",
  UpdateClientSearchTerm = "UPDATE_CLIENT_SEARCH_TERM",
  UpdateEndDate = "UPDATE_END_DATE",
  UpdatePage = "UPDATE_PAGE",
  UpdateServerSearchTerm = "UPDATE_SERVER_SEARCH_TERM",
  UpdateSortByText = "UPDATE_SORT_BY_TEXT",
  UpdateStartDate = "UPDATE_START_DATE",
  UpdateStatusFilterText = "UPDATE_STATUS_FILTER_TEXT",
}

export interface ClearSearchTermAction {
  type: ActionType.ClearSearchTerm;
}
export const clearSearchTerm = (): ClearSearchTermAction => {
  return {
    type: ActionType.ClearSearchTerm,
  };
};

export interface UpdateSearchTermAction {
  type: ActionType.UpdateClientSearchTerm;
  payload: { clientSearchTerm: string };
}
export const updateClientSearchTerm = (
  clientSearchTerm: string,
): UpdateSearchTermAction => {
  return {
    type: ActionType.UpdateClientSearchTerm,
    payload: { clientSearchTerm },
  };
};

export interface UpdateStartDateAction {
  type: ActionType.UpdateStartDate;
  payload: { startDate: moment.Moment | null };
}
export const updateStartDate = (
  startDate: moment.Moment | null,
): UpdateStartDateAction => {
  return {
    type: ActionType.UpdateStartDate,
    payload: { startDate },
  };
};

export interface UpdateEndDateAction {
  type: ActionType.UpdateEndDate;
  payload: { endDate: moment.Moment | null };
}
export const updateEndDate = (
  endDate: moment.Moment | null,
): UpdateEndDateAction => {
  return {
    type: ActionType.UpdateEndDate,
    payload: { endDate },
  };
};

export interface UpdatePageAction {
  type: ActionType.UpdatePage;
  payload: { page: number };
}
export const updatePage = (page: number): UpdatePageAction => {
  return {
    type: ActionType.UpdatePage,
    payload: { page },
  };
};

export enum StatusFilter {
  AllResults = "All results",
  Complete = "Complete",
  Incomplete = "Incomplete",
}

export interface UpdateStatusFilterTextAction {
  type: ActionType.UpdateStatusFilterText;
  payload: { statusFilter: StatusFilter };
}
export const updateStatusFilterText = (
  statusFilter: StatusFilter,
): UpdateStatusFilterTextAction => {
  return {
    type: ActionType.UpdateStatusFilterText,
    payload: { statusFilter },
  };
};

export enum SortByText {
  MostRelevant = "Most relevant",
  RecentlyCreated = "Recently created",
}

export interface UpdateSortByTextAction {
  type: ActionType.UpdateSortByText;
  payload: { sortByText: SortByText };
}
export const updateSortByText = (
  sortByText: SortByText,
): UpdateSortByTextAction => {
  return {
    type: ActionType.UpdateSortByText,
    payload: { sortByText },
  };
};

export interface UpdateServerSearchTermAction {
  type: ActionType.UpdateServerSearchTerm;
  payload: { serverSearchTerm: string };
}
export const updateServerSearchTerm = (
  serverSearchTerm: string,
): UpdateServerSearchTermAction => {
  return {
    type: ActionType.UpdateServerSearchTerm,
    payload: { serverSearchTerm },
  };
};

export interface HandleRecentSearchTermClickAction {
  type: ActionType.HandleRecentSearchTermClick;
  payload: { searchTerm: string };
}
export const handleRecentSearchTermClick = (
  searchTerm: string,
): HandleRecentSearchTermClickAction => {
  return {
    type: ActionType.HandleRecentSearchTermClick,
    payload: { searchTerm },
  };
};

export interface ResetFiltersAction {
  type: ActionType.ResetFilters;
}
export const resetFilters = (): ResetFiltersAction => {
  return {
    type: ActionType.ResetFilters,
  };
};
